export const csvDownload = (data, fileName) => {
  console.log("data", data.length);
  if (data && data.length > 0) {
    const csvHeaders = Object.keys(data[0]).join(',') + '\n';
    const csvRows = data.map(row =>
      Object.values(row).map(value => `"${value}"`).join(',')
    ).join('\n');

    const csvContent = csvHeaders + csvRows;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};


